import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  FaIconComponent,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { WaitModalComponent } from './components/waitmodal/waitmodal.component';
import { FooterComponent } from './components/footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NotAllowedComponent } from './pages/not-allowed/not-allowed.component';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { SharedRoutingModule } from './share-routing.module';
import { SiteErrorComponent } from './pages/site-error/site-error.component';
import { SiteSwitchComponent } from './components/site-switch/site-switch.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@NgModule({
  providers: [provideNgxMask()],
  declarations: [
    WaitModalComponent,
    FooterComponent,
    NotAllowedComponent,
    NotfoundComponent,
    SiteErrorComponent,
    SiteSwitchComponent,
    ConfirmDialogComponent,
    ErrorDialogComponent,
  ],
  imports: [SharedRoutingModule, CommonModule, FontAwesomeModule, NgbModule, NgxMaskDirective, NgxMaskPipe],
  exports: [
    FontAwesomeModule,
    WaitModalComponent,
    NgbModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FaIconComponent,
    FooterComponent,
    NotAllowedComponent,
    NotfoundComponent,
    ErrorDialogComponent,
  ],
})
export class SharedModule { }
